var _g, _mask, _g2, _mask2, _g3, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _rect2, _g4, _path8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgViewTransferShares = function SvgViewTransferShares(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 662 576",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#view-transfer-shares_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F4654",
    d: "M1 0h661v576H1z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "view-transfer-shares_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 256,
    y: 0,
    width: 406,
    height: 307
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M256 0h406v307H256z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43,
    fill: "#fff",
    mask: "url(#view-transfer-shares_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M818.812 181.482H469.864A129.192 129.192 0 01599.051 52.351H948a129.192 129.192 0 01-129.188 129.131z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M631.511 129.131H282.566A129.187 129.187 0 01411.756 0h348.945a129.18 129.18 0 01-129.19 129.131zM521.014 292H360.51a129.193 129.193 0 0137.853-91.31 129.17 129.17 0 0191.316-37.821h160.504a129.182 129.182 0 01-37.85 91.312A129.163 129.163 0 01521.014 292z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "view-transfer-shares_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 292,
    width: 464,
    height: 284
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#C4C4C4",
    d: "M1 292h463.099v284H1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#view-transfer-shares_svg__b)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M207.894 576h-336.101c.013-32.913 13.128-64.475 36.462-87.744 23.333-23.27 54.975-36.343 87.968-36.346h336.11c-.013 32.916-13.129 64.478-36.465 87.748C272.533 562.928 240.889 576 207.894 576zM41.252 434h-337.045c.014-32.915 13.167-64.478 36.567-87.748 23.4-23.27 55.132-36.342 88.219-36.342h337.034a123.545 123.545 0 01-9.501 47.495 124.065 124.065 0 01-27.05 40.261 124.795 124.795 0 01-40.48 26.897A125.311 125.311 0 0141.253 434z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M303.642 496.685H48.334c.013-32.915 13.157-64.478 36.54-87.748 23.385-23.27 55.095-36.342 88.158-36.342h255.247a123.511 123.511 0 01-9.465 47.497 123.972 123.972 0 01-27.016 40.268 124.601 124.601 0 01-40.446 26.898 125.059 125.059 0 01-47.71 9.427z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.883 163a2 2 0 00-2 2v47.594a2 2 0 002 2h34.062l1.083-4.042a7.93 7.93 0 015.722-13.421 7.93 7.93 0 017.93 7.93 7.905 7.905 0 01-2.275 5.56l1.065 3.973h33.344a2 2 0 002-2V165a2 2 0 00-2-2h-80.931z",
    fill: "#33BB40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M346.482 210.621l-.713-.701a.998.998 0 00-.253.96l.966-.259zm-11.378-.069l.966.259a.999.999 0 00-.244-.951l-.722.692zm-3.09 11.532l-.966-.259a1 1 0 001.466 1.125l-.5-.866zm4.317-2.492l.866-.5a.999.999 0 00-1.366-.366l.5.866zm2.493 4.317l-.866.5a.999.999 0 001.832-.241l-.966-.259zm1.96-7.316l.966-.259a1 1 0 00-1.932 0l.966.259zm1.96 7.315l-.966.259a1 1 0 001.832.241l-.866-.5zm2.492-4.317l.5-.866a1 1 0 00-1.366.366l.866.5zm4.317 2.492l-.5.866a1 1 0 001.466-1.124l-.966.258zm-1.796-17.022a6.909 6.909 0 01-1.988 4.859l1.426 1.402a8.907 8.907 0 002.562-6.261h-2zm-6.931-6.93a6.93 6.93 0 016.931 6.93h2a8.93 8.93 0 00-8.931-8.93v2zm-6.93 6.93a6.93 6.93 0 016.93-6.93v-2a8.93 8.93 0 00-8.93 8.93h2zm1.93 4.799a6.901 6.901 0 01-1.93-4.799h-2c0 2.4.947 4.58 2.487 6.184l1.443-1.385zm-1.688.434l-3.09 11.531 1.932.518 3.09-11.532-1.932-.517zm-1.624 12.656l4.317-2.492-1-1.732-4.317 2.492 1 1.732zm2.951-2.858l2.493 4.317 1.732-1-2.493-4.317-1.732 1zm4.325 4.076l1.96-7.316-1.932-.518-1.96 7.316 1.932.518zm.028-7.316l1.96 7.315 1.932-.518-1.96-7.315-1.932.518zm3.792 7.556l2.492-4.317-1.732-1-2.492 4.317 1.732 1zm1.126-3.951l4.317 2.492 1-1.732-4.317-2.492-1 1.732zm5.783 1.368l-3.071-11.463-1.932.518 3.071 11.462 1.932-.517z",
    fill: "#33BB40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M317.643 190.21a9.196 9.196 0 01-2.736-.396c-.852-.264-1.572-.636-2.16-1.116l.774-1.692c.612.468 1.254.81 1.926 1.026a7.315 7.315 0 002.214.324c.876 0 1.548-.15 2.016-.45.48-.312.72-.744.72-1.296 0-.48-.222-.846-.666-1.098-.432-.252-1.158-.492-2.178-.72-1.056-.228-1.914-.492-2.574-.792-.66-.3-1.158-.684-1.494-1.152-.336-.468-.504-1.062-.504-1.782 0-.744.204-1.41.612-1.998.408-.588.984-1.044 1.728-1.368.744-.336 1.602-.504 2.574-.504.888 0 1.734.138 2.538.414.804.264 1.464.63 1.98 1.098l-.774 1.692c-1.128-.9-2.376-1.35-3.744-1.35-.816 0-1.464.168-1.944.504-.468.324-.702.78-.702 1.368 0 .492.21.87.63 1.134.42.264 1.134.51 2.142.738 1.068.24 1.932.51 2.592.81.672.288 1.182.66 1.53 1.116.36.456.54 1.032.54 1.728 0 .756-.204 1.422-.612 1.998-.396.564-.978 1.002-1.746 1.314-.756.3-1.65.45-2.682.45zm12.091-9.18c1.056 0 1.842.3 2.358.9.516.6.774 1.506.774 2.718v5.4h-2.25v-5.274c0-.684-.132-1.182-.396-1.494-.252-.312-.654-.468-1.206-.468-.648 0-1.17.204-1.566.612-.384.408-.576.954-.576 1.638v4.986h-2.25v-12.69h2.25v5.112c.3-.468.696-.822 1.188-1.062a3.69 3.69 0 011.674-.378zm9.197 0c1.236 0 2.154.3 2.754.9.6.6.9 1.524.9 2.772v5.346h-2.142v-1.35a2.335 2.335 0 01-.972 1.098c-.432.264-.936.396-1.512.396-.588 0-1.122-.12-1.602-.36a2.85 2.85 0 01-1.134-.99 2.501 2.501 0 01-.414-1.404c0-.648.162-1.158.486-1.53.336-.372.876-.642 1.62-.81.744-.168 1.77-.252 3.078-.252h.45v-.414c0-.6-.132-1.032-.396-1.296-.252-.264-.678-.396-1.278-.396-.468 0-.96.084-1.476.252a7.13 7.13 0 00-1.494.666l-.63-1.548c.492-.312 1.086-.57 1.782-.774a7.045 7.045 0 011.98-.306zm-.522 7.542c.6 0 1.086-.198 1.458-.594.384-.408.576-.93.576-1.566v-.378h-.324c-.804 0-1.428.036-1.872.108-.444.072-.762.198-.954.378-.192.18-.288.426-.288.738 0 .384.132.702.396.954.264.24.6.36 1.008.36zm12.259-5.67l-1.314.126c-1.488.156-2.232.912-2.232 2.268v4.752h-2.25v-8.802h2.142v1.548c.456-1.056 1.398-1.632 2.826-1.728l.684-.054.144 1.89zm8.641 3.15h-5.994c.072.816.318 1.422.738 1.818.42.396 1.02.594 1.8.594.972 0 1.86-.312 2.664-.936l.648 1.548c-.408.336-.924.606-1.548.81a5.829 5.829 0 01-1.854.306c-1.44 0-2.58-.408-3.42-1.224-.828-.816-1.242-1.932-1.242-3.348 0-.9.18-1.698.54-2.394a3.945 3.945 0 011.512-1.62c.66-.384 1.404-.576 2.232-.576 1.212 0 2.166.39 2.862 1.17.708.78 1.062 1.854 1.062 3.222v.63zm-3.87-3.438c-.6 0-1.086.192-1.458.576-.36.384-.582.936-.666 1.656h4.068c-.024-.732-.204-1.284-.54-1.656-.336-.384-.804-.576-1.404-.576zm8.95 7.578c-.78 0-1.5-.096-2.16-.288-.648-.192-1.2-.468-1.656-.828l.63-1.566c.936.684 2.01 1.026 3.222 1.026.516 0 .906-.084 1.17-.252.276-.168.414-.408.414-.72 0-.264-.096-.468-.288-.612-.18-.144-.51-.276-.99-.396l-1.44-.324c-.816-.18-1.422-.474-1.818-.882-.396-.408-.594-.936-.594-1.584 0-.54.15-1.014.45-1.422.312-.42.738-.744 1.278-.972.552-.228 1.188-.342 1.908-.342.624 0 1.224.096 1.8.288a5 5 0 011.548.81l-.63 1.53c-.912-.66-1.824-.99-2.736-.99-.492 0-.876.09-1.152.27a.854.854 0 00-.414.756c0 .24.084.438.252.594.18.156.462.276.846.36l1.494.342c.876.192 1.518.498 1.926.918.408.408.612.948.612 1.62 0 .816-.33 1.464-.99 1.944-.66.48-1.554.72-2.682.72z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.705 257.992c28.106-20.193 103.176-48.462 178.611 0",
    stroke: "#33BB40",
    strokeWidth: 4,
    strokeDasharray: "9 7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M410.268 257.721l8.977-12.44 9.409 16.249-18.386-3.809z",
    fill: "#33BB40"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 192.681,
    y: 277.885,
    width: 99.357,
    height: 140.832,
    rx: 5.5,
    fill: "#2C3E50",
    stroke: "#fff",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.154 324.358c5.457-2.269 9.239-7.673 9.239-13.94 0-8.321-6.754-15.129-15.129-15.129a15.104 15.104 0 00-15.129 15.129c0 6.267 3.837 11.671 9.24 13.94-11.455 2.323-20.1 12.481-20.1 24.692h52.032c0-12.211-8.645-22.369-20.153-24.692zm-5.782 23.612l-4.7-5.025 3.836-13.886-.487-3.242h2.702l-.486 3.242 3.836 13.886-4.701 5.025z",
    fill: "#fff",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#959EA7",
    d: "M206.905 373.721h69.571v9.365h-69.571zM214.933 388.438h53.517v9.365h-53.517z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 371.962,
    y: 277.885,
    width: 99.357,
    height: 140.832,
    rx: 5.5,
    fill: "#2C3E50",
    stroke: "#fff",
    strokeWidth: 5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#view-transfer-shares_svg__clip0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.1 325.9h4.8c-2.2-1.8-.8-11.4-.2-15.1.2-1.1.3-2.2.1-3.3-1-7-7-12.5-14.4-12.5-6.7 0-12.4 4.6-14 10.8-.5 1.7-.5 3.6-.1 5.3.7 3.6 2 12.1-.4 14.7h4.9c-9.7 3.2-16.8 12.3-16.8 23h53c0-10.7-7.1-19.8-16.9-22.9zm-.3 12.5l-9.3 8.3-9.3-8.3 1-6.2-7.3-2.1 6.2-4.1 9.3 20.7 9.3-20.7 6.2 4.1-7.3 2.1 1.2 6.2z",
    fill: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#959EA7",
    d: "M386.854 373.721h69.571v9.365h-69.571zM394.882 388.438h53.517v9.365h-53.517z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "view-transfer-shares_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(395 295)",
    d: "M0 0h53v53.8H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "view-transfer-shares_svg__filter0_d",
    x: 0,
    y: -5,
    width: 671,
    height: 586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

export default SvgViewTransferShares;